<div class="u-flex u-justifyCenter">
  <div class="DatagridNoData" data-test-id="datagridError">
    @if (error) {
      <div>
        @if (error.imageUrl) {
          <img
            aria-label="Error Image"
            alt="Error Image"
            [src]="error.imageUrl"
          />
        }
        @if (error.message) {
          <p
            tabindex="0"
            class="ui-description"
            [innerHTML]="error.message"
            data-test-id="datagridErrorMessage"
          ></p>
        } @else {
          @defer {
            <ng-container
              *ngTemplateOutlet="defaultErrorMessage"
            ></ng-container>
          }
        }
      </div>
    } @else {
      @defer {
        <ng-container *ngTemplateOutlet="defaultErrorMessage"></ng-container>
      }
    }
    <ng-template #defaultMessage>
      <p tabindex="0" class="ui-description">
        Sorry, we’re having tech troubles on our end. Try refreshing the page or
        checking back later.
      </p>
    </ng-template>
  </div>
</div>
